import { render, staticRenderFns } from "./PowerBILoader.vue?vue&type=template&id=2ee58d58&"
import script from "./PowerBILoader.vue?vue&type=script&lang=js&"
export * from "./PowerBILoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports